<template>
  <div class="container-fluid">
    <div class="row mt-2">
      <div class="col-lg-12 bg-white border-radius-xl p-3">
        <Toast/>
        <div>
          <h4 class="text-center">Validar</h4>
          <hr class="horizontal dark" />
          <h6 class="mt-1">Encuentra el Certificado del Afiliado</h6>
          <div class="row">
            <div class="col-">
              <label style="font-weight: 400;">
                Ingresa los datos y valida tu consulta
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-5">
              <label for="example-text-input" class="form-control-label">Número de Certificado <span class="text-danger">*</span></label>
              <input type="text" v-model="numeroCertificado" class="form-control">
            </div>
            <div class="col-md-5">
              <label class="form-control-label">Documento de Identidad <span class="text-danger">*</span></label>
              <input type="text" v-model="documentoIdentidad" class="form-control">
            </div>
            <div class="col-md-2">
              <button class="btn btn-addiuva-dark w-100" style="margin-top:30px;" @click="validar">
                <i class="fas fa-search pr-1"></i> &nbsp; Validar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ======================================= RESPONSE ======================================= -->
    <!-- Vigente -->
    <div class="row mt-4 mb-4" v-if="estado == 'VIGENTE'">
      <div class="col-md-12 bg-gradient-success shadow text-center border-radius-md p-3">
        <span class="text-white" style="user-select:none;">
          <i class="fas fa-check-circle"></i> <span style="font-weight:600;">Vigente</span>
        </span>
      </div>
    </div>
    <!-- No encontrado -->
    <div class="row mt-4 mb-4" v-if="estado=='NO ENCONTRADO'">
      <div class="col-md-12 bg-gradient-info shadow text-center border-radius-md p-3">
        <span class="text-white" style="user-select:none;">
          <i class="fas fa-info-circle"></i> <span style="font-weight:600;">No se encontro información relacionada a los valores ingresados</span>
        </span>
      </div>
    </div>
    <!-- No encontrado -->
    <div class="row mt-4 mb-4" v-if="estado=='MORA'">
      <div class="col-md-12 bg-gradient-warning shadow text-center border-radius-md p-3">
        <span class="text-white" style="user-select:none;">
          <i class="fas fa-exclamation-triangle"></i> <span style="font-weight:600;">En mora</span>
        </span>
      </div>
    </div>
    <!-- No encontrado -->
    <div class="row mt-4 mb-4" v-if="estado=='ANULADO'">
      <div class="col-md-12 bg-gradient-danger shadow text-center border-radius-md p-3">
        <span class="text-white" style="user-select:none;">
          <i class="fas fa-times-circle"></i> <span style="font-weight:600;">Anulado</span>
        </span>
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-lg-12 bg-white border-radius-xl p-3"> -->
        <div class="row" v-if="estado!=null">
          <div class="col-lg-6 col-md-6">
            <detalle-programa
              :programa = "programa"
              :periodicidad = "periodicidad"
              :inicio = "vigencia.inicio"
              :fin = "vigencia.fin"
              :tarifa = "tarifa"
            ></detalle-programa>
            <div class="row mt-4">
              <div class="col-md-4">
                <default-info-card
                  :classIcon="tipoPago.classIcon"
                  :title="tipoPago.title"
                  :desc="tipoPago.desc"
                />
                  <!-- :price="salary.price" -->
              </div>
              <div class="col-md-4">
                <default-info-card
                  :classIcon="cuota.classIcon"
                  :title="cuota.title"
                  :desc="cuota.desc"
                />
                  <!-- :price="salary.price" -->
              </div>
              <div class="col-md-4">
                <default-info-card
                  :classIcon="proximoPago.classIcon"
                  :title="proximoPago.title"
                  :desc="proximoPago.desc"
                  :price="proximoPago.price"
                />
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6">
            <detalle-afiliados
              :afiliados = "afiliados"
            ></detalle-afiliados>
          </div>

        </div>
      <!-- </div>
    </div> -->
    <documentos-generados
      v-if="false"
      :certificado = "certificado"
      :factura = "factura"
    ></documentos-generados>
  </div>
</template>

<script>
import DefaultInfoCard from "@/examples/Cards/DefaultInfoCard.vue";
// import ArgonInput from "@/components/ArgonInput.vue";
import DetallePrograma from "./components/DetallePrograma.vue";
import DetalleAfiliados from "./components/DetalleAfiliados.vue";
import DocumentosGenerados from "./components/DocumentosGenerados.vue";
import Toast from 'primevue/toast';
import axios from 'axios';
// import authHeader from '../services/auth-header';
export default {
  name: "Validar",
  components: {
    DefaultInfoCard,
    DetallePrograma,
    DetalleAfiliados,
    DocumentosGenerados,
    Toast
  },
  data() {
    return {
      API_URL: process.env.VUE_APP_API_BASE_URL,
      numeroCertificado: null,
      documentoIdentidad: null,
      certificado: './certificado',
      factura: "/factura.url",
      estado: null,
      programa: 'Vehicular',
      tarifa: 25.50,
      periodicidad: 'Mensual',
      cantidad: 2,
      afiliados: [
        {
          nombres: 'Jhon M',
          apellidos: 'Doe',
          dob: '1988-04-14',
          edad: '35',
          documento: '123456789LP',
          telefono: '59177789887',
          email: 'jjpere1@gmail.com',
        },
        {
          nombres: 'Mary A',
          apellidos: 'Smith',
          dob: '1988-04-14',
          edad: '35',
          documento: '123456789LP',
          telefono: '59177789887',
          email: 'jjpere1@gmail.com',
        },
      ],
      vigencia: {
        inicio: new Date().toJSON().slice(0, 10),
        fin: new Date().toJSON().slice(0, 10)
      },
      tipoPago: {
        classIcon: "text-white fas fa-hand-holding-usd",
        title: "Tarjeta de Débito",
        desc: "Forma de Pago",
        price: "",
      },
      cuota: {
        classIcon: "text-white fas fa-list-alt",
        title: "3",
        desc: "Cuota",
        price: "",
      },
      proximoPago: {
        classIcon: "text-white far fa-calendar-alt",
        title: "25/01/2024",
        desc: "Fecha Próximo Cobro",
        price: "",
      },
    };
  },
  methods: {
    valueIsValid: function(value) {
      return (value !== null && value !== "" && value !== 0 && value !== [] && (typeof value !== "undefined"));
    },
    validar: function() {
      this.estado = null;
      if (this.valueIsValid(this.documentoIdentidad) && this.valueIsValid(this.numeroCertificado)) {
        let payload = {
          "numero_certificado": this.numeroCertificado,
          "numero_documento": this.documentoIdentidad
        }
        // Send Data by Axios
        let url = this.API_URL + "/afiliado/validador";
        axios({
          url: url,
          method: 'post',
          data: payload,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
        .then(response => {
          if (response.data.status) {
            let data = response.data.data;
            // certificado: './certificado',
            // factura: "/factura.url",
            this.estado = data.estado;
            this.programa = data.programa;
            this.tarifa = data.tarifa;
            this.periodicidad = data.periodicidad;
            this.cantidad = 1;
            this.afiliados = [
              {
                id_afiliado: data.afiliado.id_afiliado,
                nombres: data.afiliado.nombres,
                apellidos: data.afiliado.apellidos,
                dob: data.afiliado.fecha_nacimiento ?? '',
                edad: data.afiliado.edad,
                documento: data.afiliado.documento,
                telefono: data.afiliado.telefono,
                email: data.afiliado.email,
              }
            ];
            this.vigencia = {
              inicio: data.inicio_vigencia,
              fin: data.fin_vigencia,
            },
            this.tipoPago.title = data.metodo_pago ?? '';
            this.cuota.title = data.numero_cuota ?? '';
            this.proximoPago.title = data.fecha_proximo_pago ?? '';
          } else {
            this.$toast.add({ severity: 'error', summary: 'Error', detail: response.data.message, life: 3000 });
          }
        })
        .catch(error => {
          console.log("Error: " + error);
        });
      }
    }
  },
  computed: {
    cotizacionValidada() {
      let isValid = true;
      if (!this.valueIsValid(this.programa)) { isValid = false; }
      if (!this.valueIsValid(this.periodicidad)) { isValid = false; }
      if (!this.valueIsValid(this.cantidad)) {
        isValid = false;
      } else {
        for (let index = 1; index <= this.cantidad; index++) {
          if (!this.valueIsValid(this.nacimientos[index])) { isValid = false; }
        }
      }
      return isValid;
    }
  }
};
</script>
<style scoped>
</style>